const ValidateCheckoutForm = () => {
  const checkoutForm = document.querySelector(".woocommerce-billing-fields__field-wrapper");
  const proceedBtn = document.querySelector(".proceed-checkout-btn");
  const nextBtn = document.querySelector(".next-btn");

  if (checkoutForm) {
    const inputs = [...checkoutForm.querySelectorAll('.validate-required input')];
    // const checkbox = checkoutForm.querySelector('input[type="checkbox"]');
    const billingCountry = checkoutForm.querySelector("#billing_country");

    function validateAllCheckoutFields() {
      let allFieldsValid = true;

      inputs.forEach(input => {
        if (input.value.trim() === "") {
          allFieldsValid = false;
        }
      });

      if (billingCountry.value === "") {
        allFieldsValid = false;
      }

      // if (!checkbox.checked) {
      //   allFieldsValid = false;
      // }

      if (allFieldsValid) {
        nextBtn.disabled = false;
      } else {
        nextBtn.disabled = true;
      }
    };

    proceedBtn.addEventListener("click", () => {
      validateAllCheckoutFields();
    });

    inputs.forEach(input => {
      input.addEventListener("input", () => {
        validateAllCheckoutFields();
      });
    });

    // if (checkbox) { 
    //   checkbox.addEventListener("change", () => {
    //     validateAllCheckoutFields();
    //   });
    // }

    if (billingCountry) {
      jQuery(document).ready(function ($) {
        $("#billing_country").select2({
          placeholder: "Country",
          allowClear: true,
          minimumResultsForSearch: 8
        });
        $('#billing_country').on('select2:open', function (e) {
          const evt = "scroll.select2";
          $(e.target).parents().off(evt);
          $(window).off(evt);
        });
        //$("#billing_country").val(null).trigger("change.select2");
        $("#billing_country").on('change', function () {
          validateAllCheckoutFields();
        });
      });
    }
  };
};

export default ValidateCheckoutForm;

